<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" selector :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="关联采购单">
                            <c-input name="purchase_code"></c-input>
                        </m-search-item>
                        <m-search-item label="产品信息">
                            <c-input name="product_info" placeholder="品牌/型号/分类"></c-input>
                        </m-search-item>
                        <m-search-item label="采购员">
                            <c-input name="purchase_user_name" placeholder="请输入采购员"></c-input>
                        </m-search-item>
                        <m-search-item label="等级">
                            <c-select name="level_type" :options="LEVEL_TYPE"></c-select>
                        </m-search-item>
                        <m-search-item label="入库时间" colspan="2">
                            <c-datetime range start-name="stock_in_start_date" end-name="stock_in_end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>
                <template #operate>
                    <c-button color="main" v-if="auth('b_storage_transfer')" prepend-icon="tf-transfer" @click="codeTransfer()">批量调拨</c-button>
                    <c-button color="main" :hollow="true" v-if="auth('b_storage_in')" prepend-icon="tf-return-stock" @click="codeReturn()">批量确认返库</c-button>
                    <c-button color="main" :hollow="true" v-if="auth('b_storage_confirm_reject')" prepend-icon="tf-return-stock" @click="confirmReject()">批量同意驳回</c-button>
                    <c-button color="red" :hollow="true" v-if="auth('b_storage_out_apply')" prepend-icon="tf-return-goods" @click="purchaseOutReturn(1)">批量申请退库</c-button>
                    <c-button color="red" :hollow="true" v-if="auth('b_storage_out_confirm')" prepend-icon="tf-batch" @click="purchaseOutReturn(2)">批量确认退库</c-button>
                    <c-button v-if="auth('b_storage_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--商品信息-->
                <template #product_info="{data}">
                    <m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>
                <!--背贴码详细状态-->
                <template #state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                </template>
                <!--关联单据-->
                <template #purchase_code="{data}">
                    <div class="m-product-info">
                        <p class="m-product-info-name">采购单：{{data.purchase_code}}</p>
                        <p class="m-product-info-name">三方订单号：{{data.out_order_number}}</p>
                    </div>
                </template>
                <!--价格信息-->
                <template #purchase_price="{data}">
                    <div class="m-product-info">
                        <p class="m-product-info-name">采购：￥{{data.purchase_price||0}}</p>
                        <p class="m-product-info-name">维修：￥{{data.repair_cost||0}}</p>
                    </div>
                </template>
                <!--是否拆机-->
                <template #is_dismantle="{data}">
                    <span v-if="data.is_dismantle == 1">拆</span>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="180"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_storage_transfer')" :disabled="data.state!=10" icon="tf-transfer" @click="codeTransfer(data)">调拨</c-table-button>
                        <c-table-button v-if="auth('b_storage_in')" icon="tf-return-stock" @click="codeReturn(data)" :disabled="!(data.state == 13||data.state == 14 || data.state == 23||data.state ==24 || data.state == 33||data.state ==34)">确认返库</c-table-button>
                        <c-table-button v-if="auth('b_storage_confirm_reject')" :disabled="!data.buttons?.confirm_reject?.visible" icon="tf-accept" @click="confirmReject(data)">同意驳回</c-table-button>
                        <c-table-button v-if="auth('b_storage_remark_view')" icon="tf-detail" @click="showRemark(data)">查看备注</c-table-button>
                        <c-table-button v-if="auth('b_storage_out_apply') && data.state != 35" :disabled="data.state!=10" icon="tf-return-goods" @click="purchaseOutReturn(1,data)">申请退库</c-table-button>
                        <c-table-button v-if="auth('b_storage_out_confirm') && data.state == 35" icon="tf-accept" @click="purchaseOutReturn(2,data)">确认退库</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--调拨弹窗-->
            <code-transfer ref="codeTransfer" @resolve="$refs.view.update()"></code-transfer>
            <!--调拨返库弹窗-->
            <code-return ref="codeReturn" @resolve="$refs.view.update()"></code-return>
            <!--采购退库申请弹窗-->
            <code-purchase-out ref="codePurchaseOut" @resolve="$refs.view.update()"></code-purchase-out>
            <!--查看备注弹窗-->
            <code-remark ref="codeRemark"></code-remark>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'
import codeTransfer from "@/pages/storage/code_transfer.vue";
import codeReturn from "@/pages/storage/code_returne.vue";
import codePurchaseOut from "@/pages/storage/code_purchase_out.vue";
import codeRemark from "@/pages/storage/code_remark.vue";
import handoverReject from '@/mixins/handover_reject';

export default {
    name: 'm_wait_storage',

    mixins: [handoverReject],
    handoverModuleType: 0,

    components: {codeTransfer,codeReturn,codePurchaseOut,codeRemark},

    computed: {
        ...asyncMapState(['LEVEL_TYPE']),
        ...mapState(['saasInfo']),

    },

    data() {
        return {
            defaultSearchData: {
            },
            workType: 22
        }
    },
    methods: {

        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /**
         * 调拨
         */
        codeTransfer(data){
            var flag = true;
            var list = [];
            if(data){
                list.push(data);
            }else {
                list = this.$refs.view.$refs.list.getData('selected');
                list.forEach(item => {
                    if (item.state!=10){
                        this.$message({
                            message: '【在库】状态的背贴码才能进行调拨操作',  // 提示内容,
                            type: 'warn'
                        });
                        flag = false;
                        return
                    }
                });
            }
            if (flag){
                this.$refs.codeTransfer.open(list);
            }
        },
        /*
        * 返库
        * */
        codeReturn(data){
            var flag = true;
            var list = [];
            if(data){
                list.push(data);
            }else {
                list = this.$refs.view.$refs.list.getData('selected');
                list.forEach(item => {
                    if (!(item.state == 13 || item.state == 14 || item.state == 23 || item.state ==24 || item.state == 33 || item.state ==34)){
                        this.$message({
                            message: '只能选择【返库中】的商品进行【返库】操作',  // 提示内容,
                            type: 'warn'
                        });
                        flag = false;
                        return
                    }
                });
            }
            if (flag){
                this.$refs.codeReturn.open(list);
            }
        },
        /**
         * @param type  1=申请退库  2=确认退库
         * @param data  退库数据
         */
        purchaseOutReturn(type,data){
            var flag = true;
            var list = [];
            if(data){
                list.push(data);
            }else {
                list = this.$refs.view.$refs.list.getData('selected');
                if (type == 1){
                    list.forEach(item => {
                        if (item.state!=10){
                            this.$message({
                                message: '【在库】状态的背贴码才能进行退库申请操作',  // 提示内容,
                                type: 'warn'
                            });
                            flag = false;
                            return
                        }
                    });
                }else {
                    list.forEach(item => {
                        if (item.state!=35){
                            this.$message({
                                message: '【待退库】状态的背贴码才能进行确认退库操作',  // 提示内容,
                                type: 'warn'
                            });
                            flag = false;
                            return
                        }
                    });
                }
            }
            if (flag){
                this.$refs.codePurchaseOut.open(type,list);
            }
        },
        /****展示备注****/
        showRemark(data) {
            this.$refs.codeRemark.open(data);
        }
    }
}
</script>
<style lang="stylus" scoped>
.m-product-info {
    line-height: 20px;
    font-size: 13px;
    color: #333;

    .m-product-info-name {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .m-product-info-code {
        color: #999;
        font-size: 12px;
    }
}

// 批量生成发货单预览
.m-batch-preview-body {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.m-batch-preview {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    padding-right: 4px;

    .m-preview-group {
        background: #f7f8fa;
        border-radius: 4px;
        padding: 12px 16px;
        margin-bottom: 12px;

        .m-preview-header {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 10px;

            .m-preview-badge {
                padding: 2px 6px;
                border-radius: 2px;
                font-size: 12px;
                color: #fff;

                &.m-merge {
                    background: #3D5EFF;
                }

                &.m-single {
                    background: #07B461;
                }
            }

            .m-preview-receiver {
                flex: 1;
                font-size: 13px;
                color: #333;
                word-break: break-all;
            }

            .m-preview-total {
                font-size: 13px;
                color: #666;
                white-space: nowrap;
            }
        }

        .m-preview-orders {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;

            .m-preview-order {
                background: #fff;
                border: 1px solid #e5e5e5;
                border-radius: 4px;
                padding: 6px 10px;
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 12px;
                color: #333;

                .m-preview-order-text {
                    word-break: break-all;
                }

                .m-preview-split {
                    color: #3D5EFF;
                    cursor: pointer;
                    display: inline-flex;
                    align-items: center;
                    flex-shrink: 0;

                    i {
                        font-size: 14px;
                        font-style: normal;
                    }

                    &:hover {
                        color: #5F7FFF;
                    }
                }
            }
        }
    }

    .m-preview-empty {
        text-align: center;
        color: #999;
        padding: 30px 0;
        font-size: 13px;
    }
}

.m-preview-footer {
    margin-top: 16px;
    font-size: 13px;
    color: #666;
}
</style>
